import { GreenCtaButton } from '../../components/atomic/buttons/green_cta_button/GreenCtaButton';
import textImg from '../texts/view_result_text.png';

type ButtonProps = {
  onClick?: () => void;
};

/** Success delivery view-results CTA. */
export function Button({ onClick }: ButtonProps) {
  return (
    <GreenCtaButton
      textSrc={textImg}
      ariaLabel="Посмотреть результаты"
      onClick={onClick}
      left={92.1909}
      width={895}
      gradient={{ sizeX: 595.9, sizeY: 977.58, atX: 447.5, atY: 86.5 }}
      flash={{ left: 894.185, top: 36.302 }}
      textSize={{ width: 761, height: 95 }}
    />
  );
}
